import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  width: 28px;
  height: 28px;
  display: inline-block;
`

const GiftWrap = styled.span`
    display: inline-block;
    animation: jiggle 10s infinite;

    @keyframes jiggle {
        20% { transform: rotate(0); }
        21% { transform: rotate(3deg); }
        22% { transform: rotate(-3deg); }
        23% { transform: rotate(3deg); }
        24% { transform: rotate(-3deg); }
        25% { transform: rotate(3deg); }
        26% { transform: rotate(-3deg); }
        27% { transform: rotate(0); }
    }
`

function Gift (props) {
  return (
    <GiftWrap>
      <Svg viewBox="0 0 26 28" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M22.2921674,4.29284213 C22.2921674,2.15969116 20.5780705,0.445647946 18.4502927,0.445647946 C17.3004867,0.445647946 16.2311709,0.929233807 15.5648971,1.7674493 L13.367268,4.59911317 L11.1696389,1.7674493 C10.4979919,0.929233807 9.43410297,0.445647946 8.28424325,0.445647946 C6.15646547,0.445647946 4.43704907,2.15969116 4.43704907,4.29284213 C4.43704907,6.41524674 6.15646547,8.13466314 8.28424325,8.13466314 L18.4449195,8.13466314 C20.5780167,8.13466314 22.2921674,6.41524674 22.2921674,4.29284213 Z M8.28961643,5.93703406 C7.37617647,5.93703406 6.64005133,5.20090891 6.64005133,4.29284213 C6.64005133,3.37940217 7.37617647,2.64327703 8.28961643,2.64327703 C8.86991946,2.64327703 9.28365403,2.95492125 9.47708838,3.17522147 L11.6371052,5.93703406 L8.28961643,5.93703406 Z M18.4502927,5.93703406 L15.1189772,5.93703406 L17.2628207,3.17522147 C17.4508819,2.95492125 17.8646165,2.64327703 18.4502927,2.64327703 C19.3583057,2.64327703 20.0998578,3.37940217 20.0998578,4.29284213 C20.0998578,5.20090891 19.3583057,5.93703406 18.4502927,5.93703406 Z M1.6268779,15.4851682 L10.9224728,15.4851682 L10.9224728,27.3115291 L3.38390653,27.3115291 C2.41673481,27.3115291 1.6268779,26.5216722 1.6268779,25.5490736 L1.6268779,15.4851682 Z M15.8120094,15.4851682 L25.1130312,15.4851682 L25.1130312,25.5490736 C25.1130312,26.5216722 24.3231743,27.3115291 23.3506294,27.3115291 L15.8120094,27.3115291 L15.8120094,15.4851682 Z M10.927846,8.13466314 L10.927846,14.0558496 L1.6268779,14.0558496 L1.22926286,14.0558496 C0.901499109,14.0558496 0.64358665,13.8033103 0.64358665,13.4702271 L0.64358665,8.72033935 C0.64358665,8.3925756 0.901499109,8.13466314 1.22926286,8.13466314 L10.927846,8.13466314 Z M25.5106463,8.13466314 C25.8384637,8.13466314 26.0963225,8.3925756 26.0962687,8.72033935 L26.0962687,13.4702809 C26.0962687,13.7979909 25.8384637,14.0559033 25.5106463,14.0559033 L25.1130312,14.0559033 L15.8120094,14.0559033 L15.8120094,8.13466314 L25.5106463,8.13466314 Z" fill="#FFF" fillRule="nonzero"/>
        </g>
      </Svg>
    </GiftWrap>
  )
}

export default Gift



// WEBPACK FOOTER //
// ./src/images/icons/Gift.js